export default __webpack_public_path__ + "static/media/Jack_of_clubs.66edc4af.svg";